module.exports = __webpack_public_path__ + "static/media/news.be68ba8a.jpg";